<template>
  <div
    class="cart-cont"
    :class="{
      'scroll-cont': courseList && courseList.length > 3,
      'cart-cont-mobile': isMobile,
      'cart-cont-pc': !isMobile,
      'cart-cont-mobile-0': deviceOrientation === 0,
    }"
  >
    <el-carousel
      height="33px"
      direction="vertical"
      :interval="3000"
      indicator-position="none"
      ref="usersCarousel"
    >
      <el-carousel-item>
        <img
          class="icon"
          src="@saas/pages/assets/images/live/sale/title-icon.png"
          alt=""
        />
        <img
          class="hot-text"
          src="@saas/pages/assets/images/live/sale/hot-text.png"
          alt=""
        />
        <img
          class="icon"
          src="@saas/pages/assets/images/live/sale/title-icon.png"
          alt=""
        />
      </el-carousel-item>
      <el-carousel-item v-for="(user, index) in userList" :key="user + index">
        <p class="user-item">{{ user }}</p>
      </el-carousel-item>
    </el-carousel>
    <ul
      class="course-list"
      :class="{ 'landscape-course-list': deviceOrientation === 0 }"
    >
      <li
        v-for="(item, index) in courseList"
        :key="`${item.course_id}-${index}`"
        class="course-item"
        :class="{ 'stop-offering': item.can_enrollment !== 0 }"
      >
        <div class="cover-wrap">
          <span class="index">{{ index + 1 }}</span>
          <img class="cover" :src="handleImgUrl(item.cover_url)" alt="" />
        </div>
        <div class="info-wrap">
          <p class="name">{{ item.course_name }}</p>
          <div class="price-wrap">
            <p class="price"><span>￥</span>{{ item.real_price / 100 }}</p>
            <p v-if="showTotalPrice(item)" class="original-price">
              <span>￥</span>{{ item.total_price / 100 }}
            </p>
          </div>
        </div>
        <div class="operate-wrap">
          <button v-if="item.can_enrollment !== 0" class="stop-offer-btn">
            {{ item.can_enrollment === 1 ? "已停售" : "已售罄" }}
          </button>
          <button
            v-else
            class="sign-up-btn"
            @click.stop="jumpProductDetail(item.course_id)"
          >
            报名
          </button>
          <p class="enrollment-count">
            {{ handleEnrollmentCount(item) }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { broadCastMsg } from "@saas/service-api/src/live-sdk";
export default {
  name: "CartCont",
  props: {
    deviceOrientation: {
      type: Number,
      default: 1,
    },
    courseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    userList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    roomId: {
      type: Number,
      default: null,
    },
  },
  data: function () {
    return {
      isMobile: false,
      isLoading: false,
    };
  },
  methods: {
    jumpProductDetail(course_id) {
      this.apiBroadCastMsg();
      let url =
        process.env.VUE_APP_SAAS_WEB_URL + `/product-detail/${course_id}`;
      // 线索渠道参数
      let params = {
        course_id: this.roomInfo.course_id,
        lesson_id: this.roomInfo.lesson_id,
      };
      if (window.isElectron) {
        window.openUrlByExternal(this.appendQueryParamsToUrl(url, params));
      } else {
        window.open(this.appendQueryParamsToUrl(url, params));
      }
    },
    apiBroadCastMsg() {
      let nickname = "";
      if (this.user?.nickname) {
        nickname = this.user.nickname.substring(0, 1);
      }
      let params = {
        room_id: this.roomInfo.id,
        course_id: this.roomInfo.course_id,
        lesson_id: this.roomInfo.lesson_id,
        msg_type: "FlashSale",
        content: `${nickname}***正在抢`,
        desc: "",
      };
      broadCastMsg(params).then((res) => {
        console.log(res, "moguo-broadCastMsg========");
      });
    },
    million(value) {
      let num;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 1000) / 10 + "万";
      } else {
        num = value;
      }
      return num;
    },
    appendQueryParamsToUrl(baseUrl, params) {
      const queryString = Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&");
      return `${baseUrl}?${queryString}`;
    },
  },
  computed: {
    ...mapState("live", ["roomInfo"]),
    ...mapGetters(["user"]),
    handleEnrollmentCount() {
      return (item) => {
        if (item.show_enrollment_count === 1) {
          return `已售 ${this.million(item.sales_volume)}`;
        } else {
          return "火爆售卖中";
        }
      };
    },
    showTotalPrice() {
      return (item) => {
        return item.real_price !== item.total_price;
      };
    },
    handleImgUrl() {
      return (url) => {
        if (this.isMobile) {
          return url + "?imageView2/0/w/180";
        } else {
          return url + "?imageView2/0/w/320";
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-cont-pc {
  width: 500px;
  background: linear-gradient(
    346deg,
    #ffc4d3 0%,
    #ffdae8 61%,
    #fff0dc 120%,
    #fffae2 100%
  );
  border-radius: 15px;
  border: 2px solid #ffffff;
  padding: 12px 4px 12px 12px;
  overflow: hidden;

  ::v-deep .el-carousel--vertical {
    width: 100%;
    height: 33px;
    border-radius: 8px;
    border: 1px solid rgba(247, 202, 207, 0.75);
    margin-bottom: 10px;
    .el-carousel__item {
      display: flex;
      align-items: center;
      justify-content: center;
      .hot-text {
        width: 90px;
        height: 22px;
        margin: 0 18px;
      }
      .icon {
        width: 12px;
        height: 8px;
      }
      .user-item {
        position: relative;
        font-weight: 500;
        font-size: 18px;
        color: #ff0909;
        line-height: 22px;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
        &::before {
          width: 12px;
          height: 8px;
          content: "";
          position: absolute;
          left: -30px;
          top: 50%;
          transform: translateY(-50%);
          background: url("~@saas/pages/assets/images/live/sale/title-icon.png")
            no-repeat center;
          --icon-color: transparent;
          --icon-second-color: transparent;
          --icon-third-color: transparent;
          background-size: 100% 100%;
        }
        &::after {
          width: 12px;
          height: 8px;
          content: "";
          position: absolute;
          right: -30px;
          top: 50%;
          transform: translateY(-50%);
          background: url("~@saas/pages/assets/images/live/sale/title-icon.png")
            no-repeat center;
          --icon-color: transparent;
          --icon-second-color: transparent;
          --icon-third-color: transparent;
          background-size: 100% 100%;
        }
      }
    }
  }

  .course-list {
    max-height: 420px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .course-list {
    padding-right: 8px;
  }
  .course-list::-webkit-scrollbar {
    width: 4px;
  }
  .course-list::-webkit-scrollbar-thumb {
    background: #ffffff;
    border-radius: 2px;
  }
  .course-item:last-child {
    margin-bottom: 0;
  }
  .course-item {
    // margin-right: 4px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 110px;
    background: #ffffff;
    border-radius: 12px;
    padding: 10px;
    .cover-wrap {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      .index {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 0;
        width: 26px;
        height: 15px;
        background: rgba($color: #000000, $alpha: 0.6);
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 15px;
        text-align: center;
        border-radius: 4px 0px 4px 0px;
      }
    }
    .cover {
      width: 160px;
      height: 90px;
      margin-right: 10px;
      border-radius: 12px;
      object-fit: cover;
    }
    .info-wrap {
      height: 100%;
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        width: 100%;
        font-weight: 500;
        font-size: 18px;
        color: #0d1400;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
    }
    .price-wrap {
      display: flex;
      align-items: center;
      .price {
        margin-right: 10px;
        font-weight: 500;
        font-size: 20px;
        color: #0d1400;
        line-height: 28px;
        span {
          font-size: 12px;
        }
      }
      .original-price {
        font-weight: 400;
        font-size: 16px;
        color: #858687;
        line-height: 22px;
        text-decoration-line: line-through;
      }
    }
    .operate-wrap {
      width: 75px;
      margin-left: 7px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .sign-up-btn {
        width: 56px;
        height: 28px;
        background: linear-gradient(
          133deg,
          #ff7a00 0%,
          #ff5037 37%,
          #ff2f9a 86%,
          #ff27c0 100%
        );
        border-radius: 8px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
      }
      .enrollment-count {
        margin-top: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #0d1400;
        line-height: 20px;
      }
    }
  }
  .stop-offering {
    .cover-wrap,
    .info-wrap {
      opacity: 0.5;
    }
  }
  .stop-offer-btn {
    width: 56px;
    height: 28px;
    background: #b9b9b9;
    border-radius: 8px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    cursor: not-allowed;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }
  &.scroll-cont {
    .course-list {
      padding-right: 4px;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 500px;
      height: 69px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #ffc3d2 100%
      );
    }
  }
}
</style>
